module.exports = __webpack_public_path__ + "static/img/i2.c694b83c.png";